import { Save, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface FloatingSaveButtonProps {
  onSave: () => void;
  onCancel: () => void;
  isVisible: boolean;
  isSaving?: boolean;
}

export function FloatingSaveButton({
  onSave,
  onCancel,
  isVisible,
  isSaving = false,
}: FloatingSaveButtonProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'fixed bottom-8 right-8 flex gap-2 transition-all duration-300 transform z-50',
        isVisible
          ? 'translate-y-0 opacity-100'
          : 'translate-y-32 opacity-0 pointer-events-none'
      )}
    >
      <Button
        variant="outline"
        onClick={onCancel}
        disabled={isSaving}
        className="shadow-lg"
      >
        <X className="h-4 w-4 mr-2" />
        {t('common.cancel')}
      </Button>
      <Button
        onClick={onSave}
        disabled={isSaving}
        className="shadow-lg"
      >
        <Save className="h-4 w-4 mr-2" />
        {isSaving ? t('common.saving') : t('common.saveChanges')}
      </Button>
    </div>
  );
}
